import { get,post } from './securityRequest'


//获取用户有权限的菜单-列表
export  function menuList() {
    return get("admin/account/menu_list");
}

//获取用户有权限的菜单-树
export  function menuTree() {
    return get("admin/account/menu_tree");
}

//获取操作权限
export  function permission() {
    return get("admin/account/permission");
}

//校验
export  function verify() {
    return get("admin/account/verify");
}


// WEBPACK FOOTER //
// ./src/api/security/index.js